var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEye(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#746780",
    d: "M12 8.99c-1.66 0-3.01 1.35-3.01 3.01 0 1.66 1.35 3.01 3.01 3.01 1.659 0 3.009-1.35 3.009-3.01 0-1.66-1.35-3.01-3.01-3.01zm0-1.504A4.52 4.52 0 0116.512 12 4.52 4.52 0 0112 16.514 4.52 4.52 0 017.485 12a4.52 4.52 0 014.514-4.514zm0-.753C7.644 6.733 3.661 8.788 1.722 12c1.94 3.212 5.922 5.267 10.276 5.267 4.355 0 8.337-2.055 10.278-5.267-1.94-3.212-5.923-5.267-10.278-5.267zm0-1.505c5.057 0 9.692 2.518 11.805 6.413L24 12l-.195.359c-2.113 3.895-6.748 6.413-11.806 6.413-5.058 0-9.692-2.518-11.805-6.413L0 12l.194-.359C2.307 7.746 6.941 5.228 12 5.228z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default ForwardRef;